var render = function render(){var _vm=this,_c=_vm._self._c;return _c('va-card',{attrs:{"title":_vm.$t('tables.emptyTable')}},[_c('va-data-table',{attrs:{"fields":_vm.fields,"data":_vm.data,"no-data-label":_vm.$t('tables.noReport'),"no-pagination":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }